export default __webpack_public_path__ + "static/media/kleinbus_seite.8ac82000.jpg";